import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { Input } from "reactstrap";
import { C_Select } from "../../../CustomValidateForm";
import { url } from "../../../routes";
import { useHistory } from "react-router-dom";

const C_FilterSelectInner = (
    {
        paymentModeOptions = [],
        Input_ref = null,
        Input_Placeholder = "",
        subPageMode = "",
        value = "",
        pageMode = "",
        Input_ID = "",
        Input_disabled = true,
        onFilterChange = () => { },
        pm1,
        pm1Amt,
        pm2,
        pm2Amt,
        showInternalToggle = true,
        externalBtnRef = null
    },
    ref
) => {

    const history = useHistory();
    const isFranchisePage = history.location.pathname === url.FRANCHAISE_INVOICE;

    const [isOpen, setIsOpen] = useState(false);
    const [Inputvalue, setInputValue] = useState(value);


    const wrapperRef = React.useRef(null);
    const toggleBtnRef = React.useRef(null);
    const defaultSelect = { value: "Select", label: "Select" };
    const [paymentRows, setPaymentRows] = useState({
        paymentModeRow1: { Mode: defaultSelect , Amount: 0 },
        paymentModeRow2: { Mode: defaultSelect , Amount: 0 }
    });

    // Expose toggle control to parent
    useImperativeHandle(ref, () => ({
        openToggle: () => setIsOpen(true),
        closeToggle: () => setIsOpen(false)
    }));


    useEffect(() => {
        // paymentModeOptions.unshift({ value: "Select", label: "Select" });
        
        if (pageMode === "edit") {
            const pm1Opt = paymentModeOptions.find(x => x.label == pm1) || null;
            const pm2Opt = paymentModeOptions.find(x => x.label == pm2) || null;

            setPaymentRows({
                paymentModeRow1: { Mode: pm1Opt, Amount: pm1Amt || "" },
                paymentModeRow2: { Mode: pm2Opt, Amount: pm2Amt || "" }
            });
        }
        if (subPageMode === url.FRANCHAISE_INVOICE) {
            setInputValue(value);
        }

    }, [pm1, pm1Amt, pm2, pm2Amt, value, paymentModeOptions]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!isOpen) return;

            const clickedInside = wrapperRef.current?.contains(event.target);
            const clickedToggleBtn = toggleBtnRef.current?.contains(event.target);
            const clickedExternalBtn = externalBtnRef?.current?.contains?.(event.target);

            if (!clickedInside && !clickedExternalBtn && !clickedToggleBtn) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [isOpen]);

    useEffect(() => {
        
        if (subPageMode === url.ORDER_4) {
            const { paymentModeRow1, paymentModeRow2 } = paymentRows;
            const pm1Amt = paymentModeRow1.Amount || 0;
            const pm2Amt = paymentModeRow2.Amount || 0;
            setInputValue(Number(pm1Amt || 0) + Number(pm2Amt || 0));
        }
    }, [paymentRows])



    const handlePaymentRowChange = (rowKey, field, val) => {

        setPaymentRows(prev => {
            let updated = {
                ...prev,
                [rowKey]: { ...prev[rowKey], [field]: val }
            };
            onFilterChange({
                PaymentMode1: updated.paymentModeRow1.Mode?.label || "Select",
                PaymentMode1Amount: Number(updated.paymentModeRow1.Amount || 0),
                PaymentMode2: updated.paymentModeRow2.Mode?.label || "Select",
                PaymentMode2Amount: Number(updated.paymentModeRow2.Amount || 0),
            });


            return updated;

        })
    };

    return (
        <div>
            {/* WRAPPER NOW CONTAINS INPUT + PANEL (FIXED) */}
            <div ref={wrapperRef} style={{ position: "relative" }}>

                <Input
                    type="text"
                    id={Input_ID}
                    placeholder={Input_Placeholder}
                    value={Inputvalue}
                    innerRef={Input_ref}
                    disabled={Input_disabled}
                    onKeyDown={(e) => e.key === "Enter" && setIsOpen(true)}
                    style={{ height: "40px", paddingRight: "100px" }}
                />


                {/* INTERNAL TOGGLE */}
                {showInternalToggle !== false && (
                    <span
                        ref={toggleBtnRef}
                        onClick={() => setIsOpen(prev => !prev)}
                        style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: "12px",
                            color: "#808080",
                            cursor: "pointer",
                            background: "white",
                            borderRadius: "5px",
                            padding: "0 4px"
                        }}
                    >
                        {isOpen ? "Close X" : "Payment Mode"}
                    </span>
                )}

                {isOpen && (
                    <div
                        id="Advance-Filter"
                        className="price-drop-options"
                        style={{
                            display: "block",
                            overflow: "visible",
                            maxHeight: "unset",
                            width: externalBtnRef?.current
                                ? `${externalBtnRef.current.offsetWidth + 270}px` // you can adjust
                                : "366px",
                            background: "#ffffff",
                            padding: "12px",
                            borderRadius: "8px",
                            marginTop: "10px",
                            boxShadow: "0 2px 5px rgba(0,0,0,0.08)",
                            boxSizing: "border-box",
                            marginLeft: externalBtnRef?.current
                                ? `${externalBtnRef.current.offsetLeft - wrapperRef.current.offsetLeft}px`
                                : (isFranchisePage ? "-135px" : "-50px")
                        }}
                    >
                        <div
                            style={{
                                width: "100%",
                                padding: "10px 15px",
                                background: "#fafafa",
                                border: "1px solid #dcdcdc",
                                borderRadius: "6px",
                                boxSizing: "border-box"
                            }}
                        >
                            {[1, 2].map(row => (
                                <div
                                    key={row}
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        gap: "12px",
                                        width: "100%"
                                    }}
                                >
                                    <label style={{ width: "110px", fontSize: "13px", fontWeight: 500 }}>
                                        Payment Mode {row}
                                    </label>

                                    <C_Select
                                        options={paymentModeOptions}
                                        value={paymentRows[`paymentModeRow${row}`].Mode}
                                        onChange={(opt) =>
                                            handlePaymentRowChange(
                                                `paymentModeRow${row}`,
                                                "Mode",
                                                opt
                                            )
                                        }
                                        className="pm-select"
                                        styles={{
                                            container: (base) => ({ ...base, width: "100px" }),
                                            control: (base) => ({ ...base, minHeight: "38px", height: "38px" })
                                        }}
                                    />

                                    <label style={{ width: "80px", fontSize: "13px", fontWeight: 500 }}>
                                        Amount
                                    </label>

                                    <Input
                                        type="text"
                                        value={paymentRows[`paymentModeRow${row}`].Amount}
                                        onChange={(e) =>
                                            handlePaymentRowChange(
                                                `paymentModeRow${row}`,
                                                "Amount",
                                                e.target.value
                                            )
                                        }
                                        style={{ width: "80px" }}
                                    />




                                </div>
                            ))}
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
};

const Forwarded = forwardRef(C_FilterSelectInner);
export const C_FilterSelect = React.memo(Forwarded);
